function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import clsx from 'clsx';
import { Card, CardContent, CardMedia, Typography } from '@material-ui/core';
import LazyLoad from 'react-lazyload';
import { useStyles } from "./styles.js";
export const SectionCard = ({
  image,
  title,
  description,
  elevation,
  aosProps,
  style,
  cardClassName,
  imgClassName
}) => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(Card, _extends({}, aosProps, {
    elevation: elevation,
    className: clsx(classes.card, cardClassName),
    style: style
  }), /*#__PURE__*/React.createElement(LazyLoad, {
    height: 250
  }, /*#__PURE__*/React.createElement(CardMedia, {
    title: title,
    image: image,
    className: clsx(classes.cardImg, imgClassName)
  })), /*#__PURE__*/React.createElement(CardContent, {
    className: classes.cardContent
  }, /*#__PURE__*/React.createElement(Typography, _extends({}, aosProps, {
    align: "center",
    variant: "h6",
    gutterBottom: true
  }), title), /*#__PURE__*/React.createElement(Typography, _extends({}, aosProps, {
    align: "center",
    component: "p",
    gutterBottom: true
  }), description)));
};
SectionCard.defaultProps = {
  elevation: 0,
  aosProps: {
    'data-aos': 'fade-up',
    'data-aos-once': 'true'
  }
};
SectionCard.displayName = 'SectionCard';
export default SectionCard;